import "../assets/styles/components/spinner.scss";

export default function Spinner() {
  return (
    <div className="spinner position-fixed w-100 h-100 top-0 start-0 d-flex justify-content-center align-items-center">
      <div className="spinner__content d-flex justify-content-center align-items-center shadow-sm p-2">
        <div className="rounded"></div>
        <span className="ms-3">Caricamento</span>
      </div>
    </div>
  );
}
